import React, { useEffect, useState } from "react";
import Selector from "./Selector";

export default function Quantity({ value, itemId, update, allowZero }) {
  const [currentValue, setCurrentValue] = useState(value);
  const increase = () => {
    const args = itemId ? [itemId, value + 1] : [value + 1];
    update(...args);
  };
  const decrease = () => {
    const args = itemId ? [itemId, value - 1] : [value - 1];
    if ((!allowZero && value !== 1) || (allowZero && value !== 0)) {
      update(...args);
    }
  };

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  useEffect(() => {
    if (currentValue !== value) {
      update(itemId, currentValue);
    }
  }, [currentValue]);

  return (
    <Selector
      handleChange={(e) => setCurrentValue(e.target.value)}
      value={currentValue}
      increase={increase}
      decrease={decrease}
    />
  );
}
